import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "m-0 h-full",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "flex w-full h-full",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "questionCount" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Question", -1)
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { id: "currentQuestion" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"400"} }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { id: "allQuestions" }, "33", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionRating = _resolveComponent("QuestionRating")!
  const _component_StepperPanel = _resolveComponent("StepperPanel")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeQuestion - 116), 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(_component_Stepper, {
        linear: "",
        "unstyled:": "",
        true: "",
        "active-step": _ctx.activeSub,
        "onUpdate:activeStep": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSub) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleSensingCapabilitiesMeasurement')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 117)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "117",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 118)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "118",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 119)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "119",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 120)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "120",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 121)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "121",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 122)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 5,
                    question: "122",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 123)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 6,
                    question: "123",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 124)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 7,
                    question: "124",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 125)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 8,
                    question: "125",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 126)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 9,
                    question: "126",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 127)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 10,
                    question: "127",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 128)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 11,
                    question: "128",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleRespondingCapabilitiesMeasurement')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 129)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "129",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 130)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "130",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 131)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "131",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 132)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "132",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 133)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "133",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 134)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 5,
                    question: "134",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 135)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 6,
                    question: "135",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 136)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 7,
                    question: "136",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 137)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 8,
                    question: "137",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 138)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 9,
                    question: "138",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 139)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 10,
                    question: "139",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleLearningCapabilitiesMeasurement')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 140)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "140",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 141)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "141",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 142)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "142",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 143)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "143",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 144)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "144",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 145)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 5,
                    question: "145",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 146)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 6,
                    question: "146",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 147)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 7,
                    question: "147",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 148)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 8,
                    question: "148",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 149)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 9,
                    question: "149",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-step"])
    ])
  ]))
}